import
  {
    Container,
    StyledMarker,
    StyledTitle,
  } from './Title.styles';

const Title = ({ text, children }) =>
{
  return (
    <Container>
      <StyledMarker />
      <StyledTitle>
        {text}
      </StyledTitle>
      {children}
    </Container>
  );
};

export default Title;
